const api = {
  GET_LIST_MAPPING_QRISTAP: '/index.php?r=api/v1/channel_provider/mapping/merchant-list',
  LINK_MAPPING_QRISTAP: '/index.php?r=api/v1/channel_provider/mapping/link',
  UNLINK_MAPPING_QRISTAP: '/index.php?r=api/v1/channel_provider/mapping/unlink',
};

export default api;
